import * as React from "react";
import { connect } from "react-redux";
import { RouteComponentProps, Route } from "react-router";
import { RootState } from "~/state";
import { Nav, DefaultButton } from "office-ui-fabric-react/lib";
import NewFolder from "./NewFolder";
import Upload from "./Upload";
import UploadYoutube from "./UploadYoutube";
import { getMediaByType } from "~/state/action";
import Library from "./Library";
import { folderToNavLink } from "./helper";
import styled from "styled-components";
import Files from "react-files";
import { uploadFiles } from "~/state/media/action";
export interface Props extends RouteComponentProps<{parentId?: string}>
{
    libraryName: string;
   
}


type StateProps = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>;

const mapStateToProps = (state: RootState, ownProps: Props) => ({
    folders: getMediaByType(state, "folder")
});

const mapDispatchToProps = (dispatch: any, ownProps: Props) => ({
    uploadFiles: (files: File[], parentId: string) => dispatch(uploadFiles(files, parentId))
});

export interface ReactFilesComponent extends React.Component<any, any>
{
    removeFiles: () => void;
}

const MediaStyle = styled.div`
    display: flex;
    flex-direction: column;
    .media-navigation
    {
        flex: 1 0;
        width: 300px;
        .ms-Nav-groupContent{
            margin-bottom: 0;
        }
        .content
        {
            flex-grow: 1;
            margin: 14px;
        }
    }


`;
       
class Media extends React.Component<Props & StateProps>
{
    private reactFiles: ReactFilesComponent | null = null;
    private setReactFiles = (files: ReactFilesComponent) => this.reactFiles = files;
    state = {
        showFolders: false
    };
    public componentWillMount() 
    {
        if (typeof document !== "undefined") 
        {
            document.addEventListener("mousedown", this.onOutsideClick, false);
        }
    }

    public componentWillUnmount() 
    {
        if (typeof document !== "undefined") 
        {
            document.removeEventListener("mousedown", this.onOutsideClick, false);
        }
    }

    onOutsideClick = (e:any) =>
    {
        // if it's a buttons Save or Cancel on pop up then it's necessary to ignore this event
        const targetElmClasses = ((e.target as Element).classList);
        if (targetElmClasses.contains("save") || targetElmClasses.contains("cancel"))
        {
            return;
        }

        // hard to say why
        const targetClass = e.target.parentNode.parentNode.parentNode.className;

        // to hide dropdown when user click outside it
        if (!(targetClass.indexOf("folder-menu") !== -1 || targetClass.indexOf("ms-Nav") !== -1))
        {
            this.setState({showFolders: false});
        }
    }

    onFilesChange = (files: File[]) =>
    {   
        if (!files || files.length === 0)
        {
            return;
        }

        if (this.reactFiles !== null)
        {
            this.reactFiles.removeFiles();
        }
        const parentId = this.props.match.params.parentId;
        if (parentId)
        {
            this.props.uploadFiles(files, parentId);
            this.props.history.push(`/media/${ parentId ? parentId : "" }`);
        }
    }

    onFilesError = (error:any) =>
    {
        //TODO: handle errors
        console.log(error);
    }
    onCreateFolderClick = () =>
    {
        const parentId = this.props.match.params.parentId || "";
        this.props.history.push(`/media/${parentId}${parentId ? "/" :""}new/folder/`);
    }

    onLinkClick = (id: string) => (e: React.MouseEvent<HTMLElement>) =>
    {
        e.preventDefault();
        this.props.history.push(`/media/${id}`);
        return false;
    }

    toggleMenu = () =>
    {
        this.setState({showFolders: !this.state.showFolders });
    }

    render()
    {
        const { links } = folderToNavLink(this.props.folders, this.onLinkClick, this.props.match.params.parentId, null);
        const menu = (this.state.showFolders ? 
            <Nav selectedKey={this.props.match.params.parentId} className="media-navigation" groups={[{links}]} /> 
        : null);

        return (
            <MediaStyle>
                <FolderStyle>
                    <DefaultButton className="folder-menu" iconProps={{iconName:"FolderHorizontal"}} onClick={this.toggleMenu} text="Folders"/>
                    {menu}
                </FolderStyle>
                {this.props.match.params.parentId !== undefined ? <UploadField>
                    <Files
                        onChange={this.onFilesChange} 
                        onError={this.onFilesError}
                        ref={this.setReactFiles}
                        minFileSize={0}
                        clickable
                        multiple={true}>
                        <h2>Drop files here or click to upload to current folder</h2>
                    </Files>
                </UploadField> : null}
                <div className="content">
                    <Route path={`${this.props.match.path}`} component={Library}  />
                </div>
                
                <Route path={`${this.props.match.path}/new/folder/`} component={NewFolder}  />
                <Route path={`${this.props.match.path}/upload/`} component={Upload}  />
                <Route path={`${this.props.match.path}/youtube/`} component={UploadYoutube}  />
            </MediaStyle>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Media);

const UploadField = styled.div`
    margin-left: 10px;
    /*margin-top: 30px;*/
    .files-dropzone{
        width: 470px;
        height: 84px;
        border: 1px dashed black;
        margin-bottom: 15px;       
    }
    h2{
        text-align: center;
        font-size: 15px;
        margin-top: 32px;
    }`;

const FolderStyle = styled.div`
    position: relative;
    margin-left: 10px;
    margin-bottom: 20px;
    margin-top: 15px;
    .ms-Nav{
        position: absolute;
        z-index: 1;
        top: 18px;
        box-shadow: 0px 10px 8px rgba(0,0,0,.4);
        > .ms-Nav-group{
            box-shadow: 0px 20px 8px rgba(0,0,0,.4);
        }
    }
`;


// WEBPACK FOOTER //
// ./src/components/media/index.tsx